/***** Begin bsTabsIconBased Scripts *****/

var bsTabsIconBased = {

  init: function(tabsId, showIcons)
  {
    $("#" + tabsId + " .nav-tabs").height($("#" + tabsId + " .nav-tabs").height());

    $("#" + tabsId + " .nav-tabs li").each(function () { $(this).height($("#" + tabsId + " .nav-tabs").outerHeight()); });

    $("#" + tabsId + " .nav-tabs li").hover(function () { bsTabsIconBased.swapIcons(this); }, function () { bsTabsIconBased.swapIcons(this); });

    $("#" + tabsId + " a[data-toggle='tab']").on('click', function (e) { e.preventDefault(); $(this).tab('show'); });

    $("#" + tabsId + " a[data-toggle='tab']").on('keyup', function (e) { bsTabsIconBased.keyActivateTab(e, this); });

    $("#" + tabsId + " a[data-toggle='tab']").on('shown.bs.tab', function () { bsTabsIconBased.activateTab(tabsId); });
    
    if (!showIcons)
    {
      $("#" + tabsId + " .dropdown").addClass('noIcons');

      $("#" + tabsId + " .nav-tabs").addClass('noIcons');

      $("#" + tabsId + " .tab-content .tabPane").each(function () { $(this).addClass('noIcons'); });

      $("#" + tabsId + " .dropdown-menu li a").each(function () { $(this).on('click', function (e) { e.preventDefault(); bsTabsIconBased.showNonIconContent(tabsId, $(this).attr('data-target'), $(this).html()); }) });
    }
  },

  swapIcons: function(tabTarget)
  {
    if (!$(tabTarget).hasClass("active"))
    {
      if ($(tabTarget).find("[class*=-selected]").length > 0)
      {
        var className = $(tabTarget).find("[class*=icon-]").attr("class").split(" ")[1];

        $(tabTarget).find("[class*=icon-]").removeClass(className).addClass(className.replace("-selected", ""));
      }
      else
      {
        var className = $(tabTarget).find("[class*=icon-]").attr("class").split(" ")[1];

        $(tabTarget).find("[class*=icon-]").removeClass(className).addClass(className + "-selected");
      }
    }
  },

  keyActivateTab: function(e, tabTarget)
  {
    var code = e.keyCode || e.which;

    if (code == 13)
    {
      bsTabsIconBased.swapIcons(tabTarget);
      $(tabTarget).tab('show');
    }
  },

  activateTab: function (tabsId)
  {
    $("#" + tabsId + " ul li").not(".active").find("[class*=icon-]:not([class*=-selected])").parent().parent().each(function () { bsTabsIconBased.swapIcons(this) });

    bsTabsIconBased.updateNonIconContentDropdown(tabsId, $("#" + tabsId + " ul li.active span")[0].innerHTML);
  },

  showNonIconContent: function (tabsId, contentTarget, dropdownText)
  {
    $("#" + tabsId + " .tab-content .active").removeClass("active");

    $("#" + tabsId + " .tab-content #" + contentTarget).addClass("active");

    $("#" + tabsId + " .nav-tabs li.active").removeClass("active");

    $("#" + tabsId + " .nav-tabs li:contains('" + dropdownText + "')").addClass("active");

    bsTabsIconBased.updateNonIconContentDropdown(tabsId, dropdownText);
  },

  updateNonIconContentDropdown: function(tabsId, contentText)
  {
    $("#" + tabsId + " .dropdown .dropdown-toggle").html(contentText + '<span class="caret"></span>');
  }

};

/***** End bsTabsIconBased Scripts *****/